import React from 'react';
import { INavStep, NavStep } from './NavStep';
import { VDLColors } from '../../util/colorStyles';

export type StepNavType = 'numerical' | 'icon';

export interface IStepNavigation {
  // To set the active step color. Defaults to accent-0-dark.
  activeAccent?: VDLColors;

  // Child nodes to render within the step navigation container.
  children?: React.ReactNode;

  // To set the incomplete step color. Defaults to neutral-dark.
  incompleteAccent?: VDLColors;

  // Whether or not the navigation steps are displayed sequential or not. Defaults to true.
  sequential?: boolean;

  // Show lines between steps. When 'sequential' set to false, this property has no effect. Defaults to true.
  showLines?: boolean;

  // To set step navigation type. Defaults to numerical.
  stepNavType?: StepNavType;
}

export function StepNavigation({
  activeAccent = 'accent-0-dark',
  children,
  incompleteAccent = 'neutral-dark',
  sequential = true,
  showLines = true,
  stepNavType = 'numerical',
  ...otherProps
}: IStepNavigation) {
  const steps = [];
  const childCount = React.Children.count(children);

  React.Children.forEach(children, (child: any, idx: number): any => {
    if (child && child.type === NavStep) {
      steps.push(React.cloneElement(child, {
        ...otherProps,
        active: sequential ? child.props.active : true,
        activeAccent,
        incompleteAccent,
        lastChild: idx === (childCount - 1),
        position: idx + 1,
        showLines: sequential ? showLines : false,
        stepNavType
      } as INavStep));
    }
  });

  return (
    <div className="step-navigation-container">
      {steps}
    </div>
  );
}

StepNavigation.displayName = 'StepNavigation';
